// extracted by mini-css-extract-plugin
export default {"logo":"logo--KK3Ed","image":"image--ZuyKw"};